import 'dayjs/locale/pt-br';
import dayjs, { Dayjs } from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.locale('pt-BR');
dayjs.extend(timezone);
dayjs.extend(utc);

export const toSaoPauloTimeZone = (dateString: string | undefined) =>
  dayjs(dateString).tz('America/Sao_Paulo');

export const parseToDayjs = (
  dateString: string | undefined,
  format?: string | undefined
) => {
  if (format) {
    return dayjs(dateString).format(format);
  }
  return dayjs(dateString);
};

export const replaceTimeZone = (date: Dayjs) => {
  return `${dayjs(date).format('YYYY-MM-DDTHH:mm:ss')}${dayjs(date)
    .tz('America/Sao_Paulo')
    .format('ZZ')} `;
};

// GERE6-459 — a regra de liberação vale para o dia inteiro: o conteúdo abre às 00h00 da data
// escolhida, não no horário em que a regra foi salva.
//
// Manda sempre a mesma hora (00:00) já carimbada com o fuso de São Paulo, via replaceTimeZone —
// o mesmo caminho que avaliação, prazo de atividade e os filtros de listagem usam. Mandar só o dia
// ("2026-09-01") deixaria o valor ambíguo: quem lesse com DateTime.parse resolveria como meia-noite
// UTC, que em São Paulo é 21h do dia anterior. Totalmente qualificado, não tem o que interpretar.
//
// O .trim() não é enfeite: replaceTimeZone devolve a string com um espaço no fim, e o dayjs não
// relê isso ("Invalid Date"). Os outros usos não sentem porque mandam para coluna datetime, que o
// Rails normaliza; aqui `value` é string e fica guardada literal — sem o trim, a regra de prova ou
// atividade (que não passa pela normalização do backend) voltaria quebrada para o picker.
export const toAvailabilityDate = (date: Dayjs) =>
  replaceTimeZone(dayjs(date).startOf('day')).trim();

// Lê de volta sempre no fuso de São Paulo, para o DatePicker mostrar o mesmo dia que o aluno vê.
export const parseAvailabilityDate = (value: string | number) =>
  toSaoPauloTimeZone(String(value));

export const formatDate = (dateString: string, format = 'LLL') => {
  return parseDate(dateString).tz('America/Sao_Paulo').format(format);
};

export const parseDate = (dateString: string | undefined) => {
  return dayjs(dateString).locale('pt-BR');
};

// Período de um RangePicker no formato que os filtros `by_range_date` do atlas esperam:
// [início, fim] em dias, que o backend lê como dias inteiros em São Paulo. Sem período, undefined —
// o data provider omite o filtro.
export const toRangeDateFilter = (
  range: [Dayjs, Dayjs] | null | undefined
): [string, string] | undefined =>
  range
    ? [range[0].format('YYYY-MM-DD'), range[1].format('YYYY-MM-DD')]
    : undefined;

export const convertNumberToDate = (dateNumber: number, iso = false) => {
  const cleaned = ('' + dateNumber).replace(/\D/g, '').slice(0, 8);
  const match = cleaned.match(/^(\d{0,2})?(\d{0,2})?(\d{0,4})?$/)!;

  if (iso) {
    return [
      match[2],
      match[2] ? '-' : '',
      match[1],
      match[1] ? '-' : '',
      match[3]
    ].join('');
  }
  return [
    match[1],
    match[1] ? '/' : '',
    match[2],
    match[2] ? '/' : '',
    match[3]
  ].join('');
};

export const getRequirementDays = (weeklyNumber: number) => {
  return weeklyNumber / 60 / 24;
};

export const getRequirementWeeks = (weeklyNumber: number) => {
  return weeklyNumber / 60 / 24 / 7;
};

export const weeksToMinutes = (weeks: number) => {
  const weekInMinutes = 24 * 60 * 7;
  return weeks * weekInMinutes;
};

export const minutesToDays = (minutes: number) => {
  return minutes / 24 / 60;
};
